import { SelectBox } from '../form/select-box';
import Cookies from 'js-cookie';

class Footer {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-footer',
            categoryAttr: 'category',
            resizeHandler: null
        };

        this.settings = Object.assign({}, settings, options);

        this.$footer = element;
        this.$$categories = this.$footer.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.categoryAttr + '"]');
        this.$currencySwitch = element.querySelector('[data-currency="root"]');
        this.currencySwitchUrl = this.$currencySwitch?.getAttribute('data-currency-url');
        this.currency = null;
        this.initialize();
    }

    initialize () {
        this.checkCurrency();
        this.setEvents();

        if (this.$$categories.length > 0) {
            window.setTimeout(() => {
                this.setCategories();
            }, 250);
        }
    }

    async checkCurrency () {
        /* Currency Switch */
        if (!this.$currencySwitch) {
            return false;
        }

        const currencySwitch = new SelectBox(this.$currencySwitch);

        const applyCurrency = (currency) => {
            this.$currencySwitch.value = currency;
            if (currencySwitch.selectbox) {
                currencySwitch.selectbox.setValue(currency);
            }
            document.body.setAttribute('data-currency', currency);
        };

        let currency = Cookies.get('currency');

        if (!currency && this.currencySwitchUrl) {
            try {
                const response = await fetch(this.currencySwitchUrl);
                if (response.ok) {
                    const data = await response.json();
                    currency = data.currency.toUpperCase();
                    Cookies.set('currency', currency, { expires: 365, path: '/', sameSite: 'Lax', secure: true });
                }
            } catch (error) {
                console.error('Failed to fetch currency:', error);
            }
        }

        if (currency) {
            applyCurrency(currency);
        }

        this.$currencySwitch.addEventListener('change', () => {
            this.currency = this.$currencySwitch.value;
            Cookies.set('currency', this.currency, { expires: 365, path: '/', sameSite: 'Lax', secure: true });
            document.body.setAttribute('data-currency', this.currency);
        });
    }

    setEvents () {
        const resizeHandler = this.settings.resizeHandler;
        if (resizeHandler) {
            resizeHandler.customFunctions.push(() => {
                if (this.$$categories.length > 0) {
                    this.setCategories();
                }
            });
        }
    }

    setCategories () {
        const spreadCategoriesInArray = () => {
            const spreadArray = [];
            let topPosition = 0;
            let arrayIndex = -1;
            for (let i = 0; i < this.$$categories.length; i++) {
                const $category = this.$$categories[i];
                if ($category.offsetTop !== topPosition) {
                    arrayIndex++;
                    topPosition = $category.offsetTop;
                    spreadArray[arrayIndex] = [];
                }
                spreadArray[arrayIndex].push($category);
            }
            return spreadArray;
        };

        const calculateHeight = (categories) => {
            let maxHeight = 0;

            for (let i = 0; i < categories.length; i++) {
                const $category = categories[i];
                $category.style.minHeight = 0;
                maxHeight = $category.offsetHeight > maxHeight ? $category.offsetHeight : maxHeight;

                if (i === categories.length - 1) {
                    for (let j = 0; j < categories.length; j++) {
                        const $category = categories[j];
                        $category.style.minHeight = maxHeight + 'px';
                    }
                }
            }
        };

        const categoriesArray = spreadCategoriesInArray();

        for (let i = 0; i < categoriesArray.length; i++) {
            const categoryArray = categoriesArray[i];
            calculateHeight(categoryArray);
        }
    }
}

export default Footer;
